// TODO: studio需要同步这个配置
export const channelDivisionMap: any = {
  twitch: ['twitch_keyword', 'twitch_live'],
  navercafe: ['cafe'],
  youtube: ['youtube_keyword', 'youtube_live'],
  funcom: ['funcom forum'],
};

export const languageDivisionMap: any = {
  'zh-hant': ['zh-tw'],
  'zh-hans': ['zh'],
};

export const whiteList = ['/api/v1/ai/upload', '/api/v1/ai/summarize'];
